import { RELATION_TYPE_FRIEND } from 'store/anketa/mappers/trustees';
import { standartWhitespaceAndDashes } from 'utils/stringUtils';

import { CLASS_ORDER } from './PersonalInfo.constants';

export const convertIssuerCode = (number) => {
  const _number = String(number);
  const code = _number.slice(0, 3) + '-' + _number.slice(3);

  return code;
};

export const convertBirthPlaceVal = (val) => {
  return {
    ...val,
    birthPlace: standartWhitespaceAndDashes(val.birthPlace),
  };
};

export const checkChangeValues = (val, key, persons) => {
  const requiredFields = {
    personalInfo: ['fullName', 'birthDate'],
    contacts: ['mobilePhone'],
    passport: ['serianumber', 'issuer', 'issuerCode'],
  };
  const fields = requiredFields[key];

  if (!fields) {
    return false;
  }

  return fields.some((field) => {
    return val[field] !== persons[key][field];
  });
};

export const getNewTrustee = (addId) => {
  const newTrustee = {
    id: addId,
    fullName: '',
    birthDate: '',
    phone: '',
    relationType: RELATION_TYPE_FRIEND,
    insurance: false,
    drivingLicenseSeriesNumber: '',
    drivingLicenseIssueDate: '',
    drivingLicenseIssuer: '',
    drivingLicenseStartYear: '',
  };

  return newTrustee;
};

export const classCompare = (a, b) => {
  if (CLASS_ORDER.indexOf(a) === -1) {
    return -1;
  }

  if (CLASS_ORDER.indexOf(b) === -1) {
    return 0;
  }

  return CLASS_ORDER.indexOf(a) - CLASS_ORDER.indexOf(b);
};

export const getUniqueDocumentsClassifications = (documents) => {
  if (!documents) {
    return [];
  }

  let classifications = documents.map((document) => {
    return document.type.sysName;
  });

  classifications = [...new Set(classifications)]
    .filter((classification) => {
      return CLASS_ORDER.includes(classification);
    })
    .sort(classCompare);

  return classifications;
};

export const docGridDefault =
  "'. go go go go go go .''. . . empty_doc empty_doc . . .''. desc desc desc desc desc desс .'";

export const getUniqueClassesTemplate = (uniqueClasses) => {
  let template = "'. go go go go go go .'";
  let index = 0;
  let subString = "'. ";

  for (const uniqueClass of uniqueClasses) {
    subString += `${uniqueClass} ${uniqueClass} `;
    index++;

    if (index === 3) {
      index = 0;
      template += `${subString}.'`;
      subString = "'. ";
    }
  }

  const remainingItems = {
    0: "empty_doc empty_doc . . . . .'",
    1: "empty_doc empty_doc . . .'",
    2: "empty_doc empty_doc .'",
  };

  template += `${subString}${remainingItems[index] || ".'"}`;

  template += "'. desc desc desc desc desc desc .'";

  return template;
};
